// eslint-disable-next-line import/no-cycle
import { StoryblokComponent, storyblokEditable } from "@storyblok/react";

import Container from "@/components/elements/Container";
import Spotlight from "@/components/elements/Features/Spotlights";
import Section from "@/components/elements/Section";
import Footer from "@/components/layouts/Footer";
import { GalleryOverlay } from "@/components/layouts/GalleryGrid";
import Header from "@/components/layouts/Header";
import Hero from "@/components/layouts/Hero";

const Listing = ({ story, blok, settingsHeader, settingsFooter }) => {
  const staff = blok.spotlight.sort((a, b) => a.sort - b.sort);
  return (
    <>
      <Hero story={story} blok={blok} type="basic">
        <Header theme={"light"} settingsHeader={settingsHeader} />
      </Hero>
      <main role="main" id="main">
        <Section {...storyblokEditable(blok)}>
          <Container
            size="widest"
            className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3 md:gap-12 xl:gap-16"
          >
            {staff.map((s) => (
              <Spotlight key={s.uid} {...s} {...s.content} />
            ))}
          </Container>
        </Section>
        {blok.body
          ? blok.body.map((blk) => (
              <StoryblokComponent blok={blk} key={blk._uid} />
            ))
          : null}
      </main>
      <Footer settingsFooter={settingsFooter} />
      <GalleryOverlay bloks={blok.body} />
    </>
  );
};

export default Listing;
